import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { SubHeading } from "../ui/sub-heading";
import { ErrorDisplay } from "../ui/error";

interface UploadStepProps {
  isLoading: boolean;
  error: string;
  onFileSelect: (file: File | null) => void;
  onTextInput: (text: string) => void;
  inputText: string;
}

export function UploadStep({
  isLoading,
  error,
  onFileSelect,
  onTextInput,
  inputText,
}: UploadStepProps) {
  return (
    <>
      <SubHeading>Job specification</SubHeading>
      <Tabs defaultValue="paste" className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="paste">Paste text</TabsTrigger>
          <TabsTrigger value="upload">Upload PDF</TabsTrigger>
        </TabsList>

        <TabsContent value="upload">
          <div className="space-y-4">
            <Input
              type="file"
              accept=".pdf"
              onChange={(e) => onFileSelect(e.target.files?.[0] || null)}
              disabled={isLoading}
            />
          </div>
        </TabsContent>

        <TabsContent value="paste">
          <div className="space-y-4">
            <Textarea
              placeholder="Paste the job specification text here"
              className="min-h-[200px]"
              onChange={(e) => onTextInput(e.target.value)}
              value={inputText}
              disabled={isLoading}
            />
          </div>
        </TabsContent>
      </Tabs>
      {error && <ErrorDisplay message={error} />}
    </>
  );
}
